import { TextInput } from '@/components/ui/text-input';
import { BlurView } from 'expo-blur';
import React from 'react';
import { ActivityIndicator, Pressable, Text, View } from 'react-native';
import { AuthScreenLayout } from './components/auth-screen-layout';
import { useRegisterForm } from './hooks/use-register-form';

export function RegisterScreen() {
  const form = useRegisterForm();

  return (
    <AuthScreenLayout title="Create Account" heading="Join Flavrly" subheading="Create your account">
      <BlurView intensity={50} className="rounded-xl overflow-hidden p-6" style={{ width: '100%' }}>
        <View className="space-y-4">
          <TextInput
            placeholder="Full Name"
            value={form.name}
            onChangeText={(text) => {
              form.setName(text);
              form.clearFieldError('name');
            }}
            error={form.errors.name || undefined}
            containerClassName="my-1"
          />

          <TextInput
            placeholder="Email"
            value={form.email}
            onChangeText={(text) => {
              form.setEmail(text);
              form.clearFieldError('email');
            }}
            autoCapitalize="none"
            keyboardType="email-address"
            error={form.errors.email || undefined}
            containerClassName="my-1"
          />

          <View>
            <TextInput
              placeholder="Username"
              value={form.username}
              onChangeText={(text) => {
                form.handleUsernameChange(text);
                form.clearFieldError('username');
              }}
              autoCapitalize="none"
              autoCorrect={false}
              error={form.errors.username || undefined}
              containerClassName="my-1"
              leftIcon={<Text className="text-muted-foreground" style={{ fontSize: 15 }}>@</Text>}
              rightIcon={
                form.checkingUsername ? (
                  <ActivityIndicator size="small" className="text-warm-gray-400" />
                ) : form.usernameAvailable === true ? (
                  <Text className="text-green-500 text-lg">✓</Text>
                ) : form.usernameAvailable === false ? (
                  <Text className="text-red-500 text-lg">✕</Text>
                ) : undefined
              }
              inputContainerStyle={
                form.usernameAvailable === true
                  ? { borderColor: '#22c55e' }
                  : form.usernameAvailable === false
                    ? { borderColor: '#ef4444' }
                    : undefined
              }
            />
            {!form.errors.username && form.username.length >= 3 && (
              <Text
                accessibilityLiveRegion="polite"
                className={`text-xs mt-1 px-2 ${
                  form.checkingUsername ? 'text-white/50'
                    : form.usernameAvailable === true ? 'text-green-500'
                    : form.usernameAvailable === false ? 'text-red-500'
                    : 'text-white/70'
                }`}
              >
                {form.checkingUsername ? 'Checking availability...'
                  : form.usernameAvailable === true ? 'Username is available!'
                  : form.usernameAvailable === false ? 'Username is already taken'
                  : '3-30 characters, letters and numbers only'}
              </Text>
            )}
            {form.username.length < 3 && (
              <Text className="text-white/70 text-xs mt-1 px-2">
                3-30 characters, letters and numbers only
              </Text>
            )}
          </View>

          <TextInput
            placeholder="Password"
            value={form.password}
            onChangeText={(text) => {
              form.setPassword(text);
              form.clearFieldError('password');
            }}
            secureTextEntry
            error={form.errors.password || undefined}
            containerClassName="my-1"
          />

          <TextInput
            placeholder="Confirm Password"
            value={form.confirmPassword}
            onChangeText={(text) => {
              form.setConfirmPassword(text);
              form.clearFieldError('confirmPassword');
            }}
            secureTextEntry
            error={form.errors.confirmPassword || undefined}
            containerClassName="my-1"
          />

          <TextInput
            placeholder="XXXXX-XXXXX"
            value={form.inviteCode}
            onChangeText={(text) => {
              form.handleInviteCodeChange(text);
              form.clearFieldError('inviteCode');
            }}
            autoCapitalize="characters"
            autoCorrect={false}
            error={form.errors.inviteCode || undefined}
            helperText="Enter your 10-letter invite code"
            containerClassName="my-1"
            inputStyle={{ fontFamily: 'monospace', letterSpacing: 2 }}
          />

          <Pressable
            className="p-4 rounded-lg my-4 bg-primary"
            onPress={form.handleRegister}
            disabled={form.isLoading}
          >
            <Text className="font-semibold text-center text-warm-gray-950">
              {form.isLoading ? 'Creating Account...' : 'Create Account'}
            </Text>
          </Pressable>
        </View>
      </BlurView>

      <View className="flex-row justify-center mt-6">
        <Text className="text-warm-gray-100">Already have an account?{' '}</Text>
        <Pressable onPress={form.navigateToLogin}>
          <Text className="font-semibold underline text-warm-gray-100">Log In</Text>
        </Pressable>
      </View>
    </AuthScreenLayout>
  );
}
